<template>
  <div>
    <main>
      <div class="wide-wrapper">
        <h2>Contrology<sup>®</sup> High Mat</h2>
        <h3></h3>

        <div class="upper-content-wrapper">
          <photo-grid :feature="featureImgHtml">
            <photo
              @setFeature="setFeatureImg"
              src="contrology-walltower-highmat-4_1x.jpg"
              src2="contrology-walltower-highmat-4_2x.jpg"
              alt="Photo to Contrology High Mat"
              caption="Contrology High Mat"
            />
            <photo
              @setFeature="setFeatureImg"
              src="contrology-walltower-highmat-2_1x.jpg"
              src2="contrology-walltower-highmat-2_2x.jpg"
              alt="In-use photo of Contrology Wall Tower and High Mat"
              caption="Contrology Wall Tower and High Mat"
            />
            <photo
              @setFeature="setFeatureImg"
              src="contrology-walltower-highmat-6_1x.jpg"
              src2="contrology-walltower-highmat-6_2x.jpg"
              alt="Photo of Contrology Wall Tower and High Mat"
              caption="Contrology Wall Tower and High Mat"
            />
          </photo-grid>

          <cta-button class="cta-button wide" />

          <div class="content-wrapper">
            <section class="intro">
              <h2>Contrology<sup>®</sup> High Mat</h2>
              <h3></h3>
              <p>
                The Contrology® High Mat gives you comfortable, stable support needed to perform Pilates mat-based exercises.  Deemed essential by most Pilates professionals, this 3”(7.62cm) High Mat features proprietary high density padding and premium upholstery, enhancing floor exercise with the authentic feel of the original Pilates apparatus. Designed for lying, sitting, kneeling, and standing exercise, the High Mat  provides ample support during all movement. Doweled handles strengthen grip for extra stability, while the  durable cotton footstrap helps maintain position.  
              </p>
            </section>

            <product-selector
              :products=products
              :product=product
              :option1=option1
              :option2=option2
              :isdistcountry=isdistcountry
              :fsahsa="true"
              additionalText="30-day lead time"
            />

            <p class="post-note">
              <a href="https://www.pilates.com/company/balanced-body-patent-data">Click here</a> for <span style="font-weight: 500;">Balanced Body Patent Data</span>.
            </p>

            <section class="links">
              <icon-link
                url="warranty"
                img="icon-warranty.svg"
                alt="Warranty icon"
                title="Learn more"
              >2 Year Limited Warranty</icon-link>
              <icon-link
                url="support-highmat"
                img="icon-assembly.svg"
                alt="Assembly icon"
                title="Learn more"
              >Assembly &amp; Support</icon-link>
              <icon-link
                img="icon-upholstery.svg"
                alt="Upholstery icon"
              >Stock Upholstery: Black</icon-link>
              <icon-link
                img="icon-upholstery-colors.svg"
                alt="Color upholstery icon"
                title="Open modal"
                url="#"
                @open="showCardModal = true"
              >Upholstery Options</icon-link>
              <icon-link
                url="#accessories"
                title="See the accessories"
                img="icon-accessories.svg"
                alt="Accessories icon"
              >Accessories</icon-link>
            </section>

            <modal-card-large
              v-if="showCardModal"
              @close="showCardModal=false"
            >
            </modal-card-large>

            <cta-button class="cta-button" />
            
          </div>
        </div>

        <section class="product-info">
          <prod-accordion class="accordion-wrapper" title="Features" animation="reveal">
            <ul class="features">
              <li>Proprietary dense foam offers unparalleled feedback </li>
              <li>3” elevation offers space for hands when holding the dowel handles</li>
              <li>Two moveable moon boxes allow for proper alignment of feet during exercises such as side kick series, spine stretch forward and saw</li>
              <li>Wooden dowel handles enhance grip and stability during inverted exercises</li>
              <li>Pre-installed footstrap anchors feet when upper body is lifted away from mat</li>
              <li>Stock upholstery: Black. Custom colors available. Heavy duty vinyl upholstery is available in <a href="https://www.pilates.com/upholstery-and-woods/" target="_blank">9 standard and 21 premium colors</a>. Please call us at 916-388-2838 or <a href="mailto:info@pilates.com">email us</a> for more information, and to order premium colors</li>
            </ul>
          </prod-accordion>
          <prod-accordion class="accordion-wrapper" title="Included" animation="reveal">
            <ul class="included">
              <li>Mat with attached handles and footstrap</li>
              <li>Moon boxes</li>
            </ul>
          </prod-accordion>
          <prod-accordion class="accordion-wrapper" title="Dimensions" animation="reveal">
            <dimensions-table-high-mat />
          </prod-accordion>

          <tabs>
            <tab name="Features" :selected="true">
              <ul class="features">
                <li>Proprietary dense foam offers unparalleled feedback </li>
              <li>3” elevation offers space for hands when holding the dowel handles</li>
              <li>Two moveable moon boxes allow for proper alignment of feet during exercises such as side kick series, spine stretch forward and saw</li>
              <li>Wooden dowel handles enhance grip and stability during inverted exercises</li>
              <li>Pre-installed footstrap anchors feet when upper body is lifted away from mat</li>
              <li>Stock upholstery: Black. Custom colors available. Heavy duty vinyl upholstery is available in <a href="https://www.pilates.com/upholstery-and-woods/" target="_blank">9 standard and 21 premium colors</a>. Please call us at 916-388-2838 or <a href="mailto:info@pilates.com">email us</a> for more information, and to order premium colors</li>
              </ul>
            </tab>
            <tab name="Included">
              <ul class="included">
                <li>Mat with attached handles and footstrap</li>
                <li>Moon boxes</li>
              </ul>
            </tab>
            <tab name="Dimensions" class="dims">
              <table>
                <thead>
                  <tr>
                    <th></th>
                    <th>Length</th>
                    <th>Width</th>
                    <th>Height</th>
                    <th>Weight</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Mat w/Handles</td>
                    <td>80 1/4” (204cm)</td>
                    <td>38” (96.5cm)</td>
                    <td>3” (7.6cm)</td>
                    <td>51lbs (23.1kg)</td>
                  </tr>
                  <tr>
                    <td>Mat w/o Handles</td>
                    <td>80 1/4” (204cm)</td>
                    <td>24” (60.96cm)</td>
                    <td>3” (7.6cm)</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>Moon Box (2) - each</td>
                    <td>15.5” (39.4cm)</td>
                    <td>10.5” (26.7cm)</td>
                    <td>3” (7.6cm)</td>
                    <td>5lbs (2.3kg)</td>
                  </tr>
                </tbody>
              </table>
            </tab>
          </tabs>
        </section>
      </div>

      <section class="accessories-wrapper" id="accessories">
        <h2>Accessories for High Mat</h2>
        <div class="accessories">
          <accessory-card
            url="spring-circles"
            product="Multiple Apparatus"
            src="contrology-spring-circle1@1x.jpg"
            src2="contrology-spring-circle1@2x.jpg"
            alt="Spring Circles product photo"
            caption="Spring Circles"
          />
          <accessory-card
            url="/toe-gizmo"
            product="Multiple Apparatus"
            src="contrology_joe-toe-gizmo1@1x.jpg"
            src2="contrology_joe-toe-gizmo1@2x.jpg"
            alt="Joe's Toe Gizmo product photo"
            caption="Joe's Toe Gizmo"
          />
          <accessory-card
            url="/flash-cards"
            product="Multiple Apparatus"
            src="flashcards1@1x.jpg"
            src2="flashcards1@2x.jpg"
            alt="Pilates Mat Flashcards product photo"
            caption="Pilates Mat Flashcards"
          />
        </div>
      </section>
    </main>
    <Modal v-if="showModal" @close="showModal = false">
      <div slot="header"></div>
      <div slot="body">
        <div class="embed-container">
          <iframe title="This is an embedded iframe video" src="https://www.youtube.com/embed/uiaN-oDV4yw?autoplay=1" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
        </div>
      </div>
      <div slot="footer"></div>
    </Modal>
  </div>
</template>

<script>
import PhotoGrid from "@/components/PhotoGrid.vue";
import Photo from "@/components/Photo.vue";
import ProductSelector from "@/components/ProductSelector.vue";
import IconLink from "@/components/IconLink.vue";
import ModalCardLarge from "@/components/ModalCardLarge.vue";
import CtaButton from "@/components/CtaButton.vue";
import ProdAccordion from "@/components/ProdAccordion.vue";
import DimensionsTableHighMat from "@/components/DimensionsTableHighMat.vue";
import Tabs from "@/components/Tabs.vue";
import Tab from "@/components/Tab.vue";
import AccessoryCard from "@/components/AccessoryCard.vue";

export default {
  name: "reformer",

  metaInfo: {
    title: "High Mat - Contrology - Balanced Body",
    titleTemplate: "%s",
    meta: [
      {
        name: "description",
        content: "The Contrology® High Mat gives you comfortable, stable support needed to perform Pilates mat-based exercises.",
      },
      {
        property: "og:image",
        content: "https://s3.amazonaws.com/s3.pilates.com/contrology/contrology-walltower-highmat-4_1x.jpg"
      }
    ]
  },

  components: {
    PhotoGrid,
    Photo,
    ProductSelector,
    IconLink,
    ModalCardLarge,
    CtaButton,
    ProdAccordion,
    DimensionsTableHighMat,
    Tabs,
    Tab,
    AccessoryCard,
  },

  props: {
    isdistcountry: Boolean
  },

  data() {
    return {
      featureImgHtml: "", // PhotoGrid
      showCardModal: false, // ModalCard
      show: false, // Intro content
      modalExists: false, // Check featured image for video
      showModal: false, // Video modal in photogrid
      product: {
        label: "Select a Product",
        value: "",
        key: "name"
      },
      option1: {
        label: "Select a Color",
        value: "",
        key: "color"
      },
      option2: {},
      products: [
        // Product options
        {
          prodid: 48870362644673,
          partnumber: "18760",
          price: 900,
          name: "Contrology High Mat",
          color: "Black Upholstery",
          available: true
        },
        {
          prodid: 48870362611905,
          partnumber: "18760C",
          price: 900,
          name: "Contrology High Mat",
          color: "Adobe White Upholstery",
          available: true
        },
        {
          prodid: 48870362677441,
          partnumber: "18760C",
          price: 900,
          name: "Contrology High Mat",
          color: "Burgundy Upholstery",
          available: true
        },
        {
          prodid: 48870362710209,
          partnumber: "18760C",
          price: 900,
          name: "Contrology High Mat",
          color: "Dark Cherry Upholstery",
          available: true
        },
        {
          prodid: 48870362742977,
          partnumber: "18760C",
          price: 900,
          name: "Contrology High Mat",
          color: "Greystone Upholstery",
          available: true
        },
        {
          prodid: 48870362775745,
          partnumber: "18760C",
          price: 900,
          name: "Contrology High Mat",
          color: "Oak Upholstery",
          available: true
        },
        {
          prodid: 48870362808513,
          partnumber: "18760C",
          price: 900,
          name: "Contrology High Mat",
          color: "Sage Upholstery",
          available: true
        },
        {
          prodid: 48870362841281,
          partnumber: "18760C",
          price: 900,
          name: "Contrology High Mat",
          color: "Storm Upholstery",
          available: true
        },
        {
          prodid: 48870362874049,
          partnumber: "18760C",
          price: 900,
          name: "Contrology High Mat",
          color: "Wedgewood Upholstery",
          available: true
        },
        {
          prodid: 48868230824129,
          partnumber: 18768,
          price: 2300,
          name: "Contrology Wall Tower with High Mat",
          color: "Black Upholstery",
          available: true
        },
        {
          prodid: 48868230758593,
          partnumber: "18768C",
          price: 2300,
          name: "Contrology Wall Tower with High Mat",
          color: "Adobe White Upholstery",
          available: true
        },
        {
          prodid: 48868230889665,
          partnumber: "18768C",
          price: 2300,
          name: "Contrology Wall Tower with High Mat",
          color: "Burgundy Upholstery",
          available: true
        },
        {
          prodid: 48868230955201,
          partnumber: "18768C",
          price: 2300,
          name: "Contrology Wall Tower with High Mat",
          color: "Dark Cherry Upholstery",
          available: true
        },
        {
          prodid: 48868231020737,
          partnumber: "18768C",
          price: 2300,
          name: "Contrology Wall Tower with High Mat",
          color: "Greystone Upholstery",
          available: true
        },
        {
          prodid: 48868231086273,
          partnumber: "18768C",
          price: 2300,
          name: "Contrology Wall Tower with High Mat",
          color: "Oak Upholstery",
          available: true
        },
        {
          prodid: 48868231151809,
          partnumber: "18768C",
          price: 2300,
          name: "Contrology Wall Tower with High Mat",
          color: "Sage Upholstery",
          available: true
        },
        {
          prodid: 48868231217345,
          partnumber: "18768C",
          price: 2300,
          name: "Contrology Wall Tower with High Mat",
          color: "Storm Upholstery",
          available: true
        },
        {
          prodid: 48868231282881,
          partnumber: "18768C",
          price: 2300,
          name: "Contrology Wall Tower with High Mat",
          color: "Wedgewood Upholstery",
          available: true
        },
      ]
    };
  },

  computed: {
    nextIcon() {
      return `<svg width="13" height="27" viewBox="0 0 13 27" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M0.51922 0.624325C1.21151 -0.208109 2.33394 -0.208109 3.02623 0.624325L12.4808 11.9927C13.1731 12.8252 13.1731 14.1748 12.4808 15.0073L3.02624 26.3757C2.33395 27.2081 1.21152 27.2081 0.519224 26.3757C-0.173069 25.5432 -0.173069 24.1936 0.519224 23.3612L8.72026 13.5L0.51922 3.63883C-0.173073 2.8064 -0.173073 1.45676 0.51922 0.624325Z" fill="black"/>
</svg>`;
    },

    prevIcon() {
      return `<svg width="13" height="27" viewBox="0 0 13 27" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M12.4808 26.3757C11.7885 27.2081 10.6661 27.2081 9.97377 26.3757L0.519221 15.0073C-0.173073 14.1748 -0.173073 12.8252 0.519222 11.9927L9.97377 0.624325C10.6661 -0.208107 11.7885 -0.208107 12.4808 0.624325C13.1731 1.45676 13.1731 2.8064 12.4808 3.63884L4.27974 13.5L12.4808 23.3612C13.1731 24.1936 13.1731 25.5432 12.4808 26.3757Z" fill="black"/>
</svg>`;
    }
  },

  methods: {
    // Set PhotoGrid featured image
    setFeatureImg(html) {
      this.featureImgHtml = html;
    },

    // Toggle intro content
    toggleContent() {
      this.show = !this.show;
    },

    // Does featured image include a video?
    initModal() {
      this.modalExists = true;
    },

    // Open modal from featured image
    openModal() {
      if ( this.modalExists ) {
        this.showModal = true;
        this.modalExists = false // Reset prop
      }
    }
  }
};
</script>

<style lang="scss" scoped>
h2 {
  text-align: center;
  margin: 0;
  padding: 0;
}

h2 + h3 {
  display: none;
}

.intro h2 {
  display: none;
}

.intro h3 {
  display: block;
}

.intro p {
  font-family: var(--roboto);
  font-size: 0.9375rem;
  line-height: 1.467;
  color: #333;
}

.content-link {
  text-decoration: underline;
  cursor: pointer;
  color: #000;
}

.wide {
  display: none;
}

.links {
  margin-top: 30px;
}

.product-info {
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.25);
  border-bottom: 1px solid #010101;
}

ul {
  margin: 0;
  padding: 0;
  list-style: none;
  font-family: var(--roboto);
  font-size: 0.875rem;
  line-height: 1.214;
  color: #333;
}

.features li {
  background: url("https://s3.amazonaws.com/s3.pilates.com/contrology/icon-check-basic.svg")
    no-repeat left center;
  padding-left: 20px;
}

.included li {
  background: url("https://s3.amazonaws.com/s3.pilates.com/contrology/icon-check-feature.svg")
    no-repeat left center;
  padding-left: 40px;
}

li {
  border-bottom: 1px solid #c4c4c4;
  padding-top: 10px;
  padding-bottom: 10px;
}

li:last-of-type {
  border-bottom: none;
}

.tabs-wrapper {
  display: none;
}

.accessories-wrapper {
  margin-top: 30px;
}

.accessories-wrapper h2 {
  margin: 2.5rem 0 1.5rem;
}

.accessories {
  display: flex;
  flex-flow: row wrap;
  justify-content: center;
}

.embed-container {
  position: relative;
  padding-bottom: 56.25%;
  height: 0;
  overflow: hidden;
  max-width: 100%;
}

.embed-container iframe,
.embed-container object,
.embed-container embed { 
  position: absolute; 
  top: 0; 
  left: 0; 
  width: 100%; 
  height: 100%; 
}

.notice {
  border: 1px solid #000000;
  padding: 0 10px;
  margin-bottom: 30px;
}

.notice-wide {
  display: none;
}

.post-note {
  -webkit-box-ordinal-group: 3;
  -ms-flex-order: 3;
  order: 3;
  font-family: var(--roboto);
  font-size: 0.75rem;
  line-height: 1.25;
  color: var(--black);
  margin-bottom: 12px;
}

::v-deep .VueCarousel {
  max-width: 900px;
  margin: 0 auto;
}

::v-deep .VueCarousel-dot-container {
  display: block;
  margin-top: 0 !important;
  padding: 0;
  text-align: right;
}

::v-deep .VueCarousel-dot {
  margin-top: 0 !important;
  padding: 0 7px !important;
}

::v-deep .VueCarousel-navigation-button:focus {
  outline: none;
}

::v-deep .VueCarousel-navigation-prev {
  left: 4px;
}

::v-deep .VueCarousel-navigation-next {
  right: 4px;
}

::v-deep .VueCarousel-navigation--disabled {
  opacity: 0.3;
}

@media only screen and (min-width: 768px) {
  h2 + h3 {
    display: block;
    margin: 0;
  }

  .intro h3 {
    display: none;
  }

  .upper-content-wrapper {
    padding: 0 80px;
  }

  .content-wrapper {
    max-width: 530px;
    margin: 0 auto;
  }

  .links {
    column-count: 3;
    position: relative;
    margin-top: 15px;
  }

  .links > * {
    -webkit-column-break-inside: avoid;
    page-break-inside: avoid;
    break-inside: avoid;
  }

  .icon-link {
    margin-top: 0;
    height: 27px;
  }

  ::v-deep .modal-card-wrapper {
    position: absolute;
    top: 160%;
    left: 10%;
    width: 80%;
    margin: 0 auto;
  }

  .tabs-wrapper {
    display: block;
    max-width: 810px;
    margin: auto auto 50px;
  }

  .dims {
    max-width: 650px;
    margin: 0 auto;
  }

  .dims table {
    border-collapse: collapse;
    font-family: "Roboto", Helvetica, Arial, sans-serif;
    line-height: 1.25;
    color: #000;
    font-size: 0.75em;
    margin: 13px auto 0;
  }

  .dims th,
  .dims td {
    text-align: left;
    width: 20%;
    padding: 5px 10px;
    border: 1px solid #c4c4c4;
  }

  .dims td {
    height: 50px;
  }

  .dims tr th:first-of-type,
  .dims tr td:first-of-type {
    background-color: rgba(255, 255, 255, 0.5);
  }

  .table {
    max-width: 650px;
    margin: 0 auto;
  }

  .table table {
    border-collapse: collapse;
    font-family: "Roboto", Helvetica, Arial, sans-serif;
    line-height: 1.25;
    color: #000;
    font-size: 0.75em;
    margin: 13px auto 0;
  }

  .table th,
  .table td {
    text-align: left;
    width: 20%;
    padding: 5px 10px;
    border: 1px solid #c4c4c4;
  }

  .table td {
    height: 50px;
  }

  .table tr th:first-of-type,
  .table tr td:first-of-type {
    background-color: rgba(255, 255, 255, 0.5);
  }

  .product-info {
    border: none;
    box-shadow: none;
  }

  li:last-of-type {
    border-bottom: 1px solid #c4c4c4;
  }

  .accordion-wrapper {
    display: none;
  }

  .accessories {
    flex-flow: row nowrap;
  }
}

@media only screen and (min-width: 1024px) {
  .upper-content-wrapper {
    padding: 0 45px;
    display: flex;
    align-items: flex-start;
    max-width: 900px;
    margin: 0 auto 30px;
  }

  .content-wrapper {
    width: 340px;
    display: flex;
    flex-flow: column nowrap;
  }

  .intro {
    order: 1;
    margin-top: 15px;
  }

  .cta-button {
    order: 3;
    margin: 0;
  }

  .notice {
    order: 4;
    margin-bottom: 0;
    margin-top: 10px;
  }

  .links {
    column-count: 1;
    order: 5;
  }

  ::v-deep .modal-card-wrapper {
    top: 100%;
  }

  .icon-link {
    margin: 0;
    height: 27px;
  }
}

@media only screen and (min-width: 1208px) {
  .wide-wrapper {
    background-color: rgba(255, 255, 255, 0.75);
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: auto 100px 120px auto;
    position: relative;
    z-index: 0;
    max-width: 1050px;
    margin: 0 auto;
  }

  .upper-content-wrapper {
    display: contents;
  }

  .photo-grid-wrapper {
    grid-column: 1 / span 1;
    grid-row: 1 / span 2;
  }

  .content-wrapper {
    width: auto;
    grid-column: 2 / span 1;
    grid-row: 1 / span 1;
    margin: 50px 30px 20px 0;
    max-width: 600px;
  }

  .product-info {
    grid-column: 2 / span 1;
    grid-row: 2 / span 3;
    margin-right: 30px;
    max-width: 512px;
  }

  .cta-button,
  .notice {
    display: none;
  }

  .notice-wide {
    display: block;
    border: 1px solid #000000;
    padding: 0 10px;
    margin: 0 32px;
    height: 240px;
  }

  .cta-button.wide {
    display: flex;
    grid-column: 1 / span 1;
    grid-row: 3 / span 1;
    justify-self: center;
    margin: 0 80px 30px auto;
  }

  .intro h2,
  .intro h3 {
    display: block;
    text-align: left;
  }

  .wide-wrapper > h2,
  .wide-wrapper > h3 {
    display: none;
  }

  .links {
    column-count: 2;
    max-width: 400px;
  }

  ::v-deep .modal-card-wrapper {
    top: 40%;
  }

  .icon-link {
    // margin: 1px;
    height: 27px;
  }

  ::v-deep .tabs-details {
    background-color: transparent;
    padding: 10px 0 0;
  }
}
</style>
